import {createAction} from '@reduxjs/toolkit'

/** 개별/통합 입력 선택 */
export const setParticularInput = createAction<boolean>('additionalOption/setParticularInput')

/** 옵션 통합 입력 */
export const setIndividuallyInputOption = createAction<{name: string; value: string; exposeOrder: number}>(
    'additionalOption/setIndividuallyInputOption',
)
/** 개별 옵션 입력 */
export const setParticularInputOption = createAction<{
    itemId: string
    name: string
    value: string
    exposeOrder: number
}>('additionalOption/setParticularInputOption')
